import { signIn } from 'aws-amplify/auth';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';

type ReturnValue = {
  /** ユーザー名。 */
  username: string;
  /** パスワード。 */
  password: string;
  /** エラーメッセージ。 */
  errorMessage: string;
  /** ユーザー名を変更するハンドラ。 */
  handleChangeUsername: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** パスワードを変更するハンドラ。 */
  handleChangePassword: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** サインインボタンをクリックしたときのハンドラ。 */
  handleClickSignInButton: VoidFunction;
};

export const useSignInForm = (): ReturnValue => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleChangeUsername = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(e.target.value);
  };

  const handleChangePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  const handleClickSignInButton = async () => {
    try {
      queryClient.clear();
      await signIn({ username, password });
      navigate('/jian-list');
    } catch (error) {
      setErrorMessage('サインインに失敗しました。');
    }
  };

  return {
    username,
    password,
    errorMessage,
    handleChangeUsername,
    handleChangePassword,
    handleClickSignInButton,
  };
};
